// extracted by mini-css-extract-plugin
module.exports = {"form":"form--j_cXF","formSavePath":"formSavePath--sTftk","formLabel":"formLabel--TQnJp"};